<template>
  <div>
    <div>
      <el-form
      
        :label-position="labelPosition"
        :model="headofficeInfo"
        :label-width="LanguageId == 1 ? '100px' : '170px'"
        :size="size"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('organstructure.corporateName')">
              <el-input v-model="headofficeInfo.corporateName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('organstructure.companCode')">
              <el-input
                v-model="headofficeInfo.companyCode"
                :disabled="true"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item :label="$t('organstructure.contacts') + '：'">
              <el-input
                v-model="headofficeInfo.contacts"
                :placeholder="$t('organstructure.inputlinecontacts')"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item :label="$t('operatormgr.mobileTel') + '：'">
              <el-input
                v-model="headofficeInfo.telephone"
                oninput="if(value.length>11)value=value.slice(0,11)"
                :placeholder="$t('organstructure.inputtelphone')"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item :label="$t('organstructure.phone')">
              <el-input
                v-model="headofficeInfo.phone"
                :placeholder="$t('organstructure.inputphone')"
                oninput="if(value.length>11)value=value.slice(0,11)"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item :label="$t('organstructure.fax')">
              <el-input
                v-model="headofficeInfo.fax"
                :placeholder="$t('organstructure.inputfax')"
              ></el-input> </el-form-item
          ></el-col>

          <el-col :span="12"
            ><el-form-item :label="$t('organstructure.email')">
              <el-input
                v-model="headofficeInfo.email"
                :placeholder="$t('organstructure.inputemail')"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('organstructure.companyAddress') + '：'"
              prop="name"
            >
              <el-input
                v-model="headofficeInfo.companyAddress"
                :placeholder="$t('organstructure.inputcompanyAddress')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$t('organstructure.companyProfile')"
              prop="desc"
            >
              <el-input
                type="textarea"
                v-model="headofficeInfo.companyProfile"
                :placeholder="$t('organstructure.inputcompanyProfile')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button :size="size" type="primary" @click="save">{{
            $t("public.save")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import language from "@/utils/getLanguageId";
import { mapState } from "vuex";
import settings from "@/settings";
export default {
  data() {
    return {
      labelPosition: "right",
      headofficeInfo: {},
      companyCode: "", //公司编码
      LanguageId: 1,
    };
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      size: (state) => state.app.size,
      operator: (state) => state.user.operator,
    }),
  },
  mounted() {
     const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
    this.queryheadinfo();
    this.LanguageId = language(this.$store.getters.locale);
  },
  methods: {
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.headofficeInfo = this.$options.data().headofficeInfo;
    },
    open2() {
      this.$message({
        message: this.$t("public.hasSaved"),
        type: "success",
      });
    },
    open4() {
      this.$message.error(this.$t("public.SaveFail"));
    },
    save() {
      this.$emit("newheadofficeInfo", this.headofficeInfo);
      console.log(this.headofficeInfo);
      var inputtelNo = this.headofficeInfo.phone;
      var contactNo = this.headofficeInfo.telephone;
      const regex = /^1[3-9]\d{9}$/;
      if (
        contactNo !== null &&
        contactNo !== undefined &&
        contactNo !== "" &&
        !regex.test(contactNo)
      ) {
        this.$message({
          message: this.$t("drivermanagement.inputphone"),
          type: "warning",
        });
      } else if (
        contactNo !== null &&
        contactNo !== undefined &&
        contactNo !== "" &&
        !regex.test(contactNo)
      ) {
        this.$message({
          message: this.$t("drivermanagement.inputphone"),
          type: "warning",
        });
      } else {
        this.$api
          .saveCompanyInfo({
            OptID: this.operator.OperatorId,
            corporateName: this.headofficeInfo.corporateName,
            companyAddress: this.headofficeInfo.companyAddress, //公司地址
            phone: this.headofficeInfo.phone, //公司电话
            fax: this.headofficeInfo.fax, //公司传真
            email: this.headofficeInfo.email, //公司E-mail
            telephone: this.headofficeInfo.telephone, //联系电话
            contacts: this.headofficeInfo.contacts, //联系人
            companyProfile: this.headofficeInfo.companyProfile, //公司简介
          })
          .then((res) => {
            if (res && res.code == 200) {
              this.open2();
              this.queryheadinfo();
              //companyID存在缓存中
              localStorage.setItem("companyId", res.companyID);
            } else {
              this.open4();
            }
          });
      }
    },
    queryheadinfo() {
      this.$api
        .headOfficeSearch({
          companyID: this.operator.CompanyId,
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.headofficeInfo = res.headOfficeInfo;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
